import styled from "styled-components";
import { darken } from "polished";
import { IFlagProps } from "./interfaces";

export const Flag = styled.div<IFlagProps>`
    position: absolute;
    top: 10px;
    right: -8px;
    color: ${p => p.theme.c.whiteOnActive};
    font-size: ${p => p.locale === "el" ? 14 : 15}px;
    padding: 4px 10px 6px 8px;
    background-color: ${p => p.theme.c.info};
    box-shadow: 0 0 2px 0 ${p => p.theme.c.blackShadow3};
    display: flex;
    align-items: center;
    z-index: 2;
    white-space: nowrap;
    border-radius: 6px 0 0 6px;

    .Back {
        position: absolute;
        top: 100%;
        right: 0;
        fill: ${p => darken(0.1, p.theme.c.info)};
    }

    .i-meta,
    .i-clock,
    .i-publish {
        margin: -4px 4px -7px -7px;
        font-size: 32px;
        color: ${p => p.theme.c.whiteOnActive};
    }
`;

export const ExperienceFlag = styled(Flag)`
    top: 10px;
    right: auto;
    border-radius: 0 6px 6px 0;
    padding: 4px 8px 6px 10px;
    left: -8px;
    background-color: ${p => p.theme.c.boost};
    .Back {
        left: 0;
        right: auto;
        fill: ${p => darken(0.1, p.theme.c.boost)};
    }
`;
